export const APPLE_APP_STORE_URL =
  'https://apps.apple.com/gb/app/ovo-energy/id626316021';

export const GOOGLE_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.ovo.energy';

export const DD_SETUP_URL =
  'https://account.ovoenergy.com/payments/direct-debit/setup';

export const OVO_BEYOND_URL = 'https://www.ovoenergy.com/beyond';
